import PrivacyPage from '@/views/leagal/PrivacyPage'

export default function Page() {
  return <PrivacyPage />
}
